import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import { useCallback } from 'react'
import { DemoWalletTypes } from './DemoWalletTypes'
import ClickAwayListener from 'components/common/ClickAwayListener'
import Divider from 'components/common/Divider'
import { Typography } from 'components/common'
import BaseModal from 'components/modals/BaseModal'

export const DemoSelectWallet: React.FC = () => {
  const { setDemoWalletLinking, setDemoWalletLinked } =
    useCollectiveDemoContext()

  const close = useCallback(() => {
    setDemoWalletLinking('init')
    setDemoWalletLinked(false)
  }, [setDemoWalletLinked, setDemoWalletLinking])

  return (
    <BaseModal classNames={'p-0'} zIndex={4000} onClose={close}>
      <ClickAwayListener onClickAway={close}>
        <div className="flex w-[700px] h-[400px]">
          <div className="flex flex-1 flex-col p-8 justify-center bg-gray-200">
            <Typography size="heading-xl">Connect your wallet</Typography>
            <br />
            <Typography size="heading">
              {`Log into your crypto wallet. If you don't currently have a wallet, you'll need to create one to join a DAO.`}
            </Typography>
          </div>

          <div className="flex-[1_0_0%] p-4">
            <div>Available Wallets</div>

            <Divider />

            <div className="my-4">
              <div className="grid grid-cols-1 gap-2">
                <DemoWalletTypes
                  image="/static/favicon.png"
                  text="Demo Meta Mask"
                />

                <DemoWalletTypes
                  disabled
                  image="/static/collective/metaMaskLogo.png"
                  text="Meta Mask"
                />
                <DemoWalletTypes
                  disabled
                  image="/static/collective/walletConnectLogo2.png"
                  text="Wallet Connect"
                  imageHeight={22}
                />
                <DemoWalletTypes
                  disabled
                  image="/static/collective/coinbaseLogo.png"
                  text="Coinbase"
                />
              </div>
            </div>
          </div>
        </div>
      </ClickAwayListener>
    </BaseModal>
  )
}
